import { all, fork } from 'redux-saga/effects';
import { watchAbout } from './sagas/about';
import { watchAlerts } from './sagas/alerts';
import { watchApp } from './sagas/app';
import { watchCatalog } from './sagas/catalog';
import { watchHome } from './sagas/home';
import { watchStaff } from './sagas/staff';
import { watchTeams } from './sagas/teams';

export function* sagas() {
  yield all([
    watchAbout(),
    watchAlerts(),
    watchApp(),
    watchCatalog(),
    watchHome(),
    watchStaff(),
    watchTeams(),
  ]);
}

export function combineSagas(allSagas) {
  return function* combinedSagas() {
    yield all(allSagas.map(s => fork(s)));
  };
}
